<!-- eslint-disable vue/no-mutating-props -->
<template>
  <card :title="$t('tools.loanRent')" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(externalReserve)">
        <div class="row">
          <div class="col-md-6">
            <material-input-field
              id="externalUserInput"
              ref="externalUserInput"
              v-model="externalUser"
              :name="'externalUser'"
              variant="static"
              :label="$t('tools.loanRentTo') + ' *'"
              :placeholder="$t('common.name')"
            />
            <material-input-field
              id="externalUserEmailInput"
              ref="externalUserEmailInput"
              v-model="externalUserEmail"
              :name="'externalUserEmail'"
              variant="static"
              :label="$t('tools.loanRentToEmail')"
              :placeholder="$t('users.email')"
            />
            <material-input-field
              id="externalUserPhoneNumberInput"
              ref="externalUserPhoneNumberInput"
              v-model="externalUserPhoneNumber"
              :name="'externalUserPhoneNumber'"
              variant="static"
              :label="$t('tools.loanRentToPhoneNumber')"
              :placeholder="$t('tools.loanRentToPhoneNumber')"
            />
          </div>
          <div class="col-md-6">
            <label class="col-md-7 col-form-label">{{$t('tools.loanOrRent')}} *</label>
            <el-select v-if="!rentalsOnly" ref="loanRentInput" v-model="loanOrRent" :class="selectClass" size="large" :placeholder="$t('tools.loanRent')">
              <el-option :value="$t('tools.loan')">{{$t('tools.loan')}}</el-option>
              <el-option :value="$t('tools.rent')">{{$t('tools.rent')}}</el-option>
            </el-select>
            <material-input-field v-else id="loanRentDisabled" name="loanRentDisabled" :model-value="$t('tools.rent')" disabled :placeholder="$t('tools.rent')" variant="static" />
          </div>
          <div v-if="loanOrRent === this.$t('tools.rent') && toolIds === ''" class="col-md-6">
            <material-input-field
              id="dailyPriceInput"
              ref="dailyPriceInput"
              v-model="dailyPrice"
              :name="'dailyPrice'"
              variant="static"
              :label="$t('tools.dailyPrice')"
              :placeholder="$t('tools.dailyPrice')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <material-input-field
              id="maxReservationDaysInput"
              ref="maxReservationDaysInput"
              v-model="maxReservationDays"
              :name="'maxReservationDays'"
              variant="static"
              :label="$t('tools.maxReservationDays')"
              :placeholder="$t('tools.maxReservationDays')"
            />
          </div>
          <div class="col-md-6">
            <label class="col-form-label">{{ $t('tools.backdatedReservationDate') }}</label>
            <input
              id="backdatedReservationDateInput"
              ref="backdatedReservationDateInput"
              v-model="backdatedReservationDate"
              type="date"
              class="form-control date-clickable"
              :max="todayDate"
              @click="$refs.backdatedReservationDateInput.showPicker()"
            />
          </div>
        </div>
        <div v-if="multiTool" class="row">
          <div class="col-md-6">
            <material-input-field
              id="quantityInput"
              ref="quantityInput"
              v-model="quantity"
              :name="'quantity'"
              variant="static"
              :label="$t('tools.quantity') + ' *'"
              :placeholder="$t('tools.quantity')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <material-checkbox v-if="!forceProjectConnectionOnRentals" v-model="connectToProject" @change="onConnectToProjectChange">{{$t('projects.connectToProject')}}</material-checkbox>
            <div v-else class="mb-3 text-muted font-weight-bold">
              <i class="material-icons text-success me-2" style="vertical-align: middle;">check_circle</i>
              {{$t('projects.projectConnectionRequired')}}
            </div>
          </div>
        </div>
        <div v-if="connectToProject" class="row mb-3">
          <div class="col-md-12 d-flex align-items-center flex-wrap gap-2">
            <material-button type="button" color="dark" size="sm" @click.prevent="showProjectPickModal = true">
              <i class="material-icons me-1" style="font-size:1rem;vertical-align:middle">work_outline</i>
              {{ selectedProject ? $t('projects.changeProject') : $t('tools.pickProject') }}
            </material-button>
            <span v-if="selectedProject" class="rlf-selected-project">
              <span v-if="selectedProjectKey" class="text-secondary me-1">[{{ selectedProjectKey }}]</span>{{ selectedProjectName }}<span v-if="selectedProjectPhaseName" class="text-secondary"> — {{ selectedProjectPhaseName }}</span>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button variant="gradient" color="dark" @click="externalReserve">{{$t('common.submit')}}</material-button>
          </div>
        </div>
      </form>
    </Form>
    <project-pick-modal
      v-model:show="showProjectPickModal"
      :status-filter="2"
      @confirm="onProjectConfirmed"
    />
  </card>
</template>
<script>
import api from "../../services/api"
import { ElSelect, ElOption } from 'element-plus';
import { Form } from 'vee-validate';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import ProjectPickModal from "../../components/Modals/ProjectPickModal.vue";
import { getCustomerConfig } from '../Settings/customerConfigHelper';

export default {
  components: { ElSelect, ElOption, Form, Card, MaterialInputField, MaterialButton, MaterialCheckbox, ProjectPickModal },
  props: { toolId: { type: String, default: '' }, toolIds: { type: String, default: '' }, multiTool: { type: Boolean, default: false }, toolsAvailable: { type: Number, default: 0 } },
  emits: ['close', 'refresh-data'],

  data() {
    return {
      quantity: '',
      selectedProject: null, selectedProjectKey: '', selectedProjectName: '',
      selectedProjectPhase: null, selectedProjectPhaseName: '',
      showProjectPickModal: false,
      connectToProject: false,
      externalUser: '', externalUserEmail: '', externalUserPhoneNumber: '', backdatedReservationDate: '', maxReservationDays: '', dailyPrice:'', loanOrRent: '',
      rentalsOnly: false,
      forceProjectConnectionOnRentals: false,
    };
  },
  computed: {
    selectClass() { let d = localStorage.getItem('darkMode'); return (d === null || d === 'false') ? 'select-standard' : 'select-primary'; },
    todayDate() { return new Date().toISOString().slice(0, 10); }
  },
  created() {
    getCustomerConfig('EnableRentalsOnly').then(config => {
      this.rentalsOnly = config === '' ? false : config;
      if (this.rentalsOnly) {
        this.loanOrRent = this.$t('tools.rent');
      }
    });
    getCustomerConfig('ForceProjectConnectionOnRentals').then(config => {
      this.forceProjectConnectionOnRentals = config === '' ? false : config;
      if (this.forceProjectConnectionOnRentals) {
        this.connectToProject = true;
      }
    });
  },
  methods: {
    onConnectToProjectChange(){
      if(!this.connectToProject) {
        this.selectedProject = null;
        this.selectedProjectKey = '';
        this.selectedProjectName = '';
        this.selectedProjectPhase = null;
        this.selectedProjectPhaseName = '';
      }
    },
    onProjectConfirmed(selection) {
      this.selectedProject = selection.projectId;
      this.selectedProjectKey = selection.projectKey || '';
      this.selectedProjectName = selection.projectName || '';
      this.selectedProjectPhase = selection.phaseId;
      this.selectedProjectPhaseName = selection.phaseName || '';
      this.showProjectPickModal = false;
    },
    cancel(){ this.$emit('close'); },
    async externalReserve() {
      if (!this.validateInput()) return;
      let rented = this.loanOrRent !== this.$t('tools.loan');
      try {
        let url = '/Tool/Reserve/External';
        if (this.toolIds !== '') {
          url = '/Tool/Reserve/External/Many';
        }
        await api.post(url, { toolId: this.toolId !== '' ? this.toolId : null, toolIds: this.toolIds !== '' ? this.toolIds : null, externalUser: this.externalUser, rented, projectId: this.selectedProject, projectPhaseId: this.selectedProjectPhase || null, maxReservationDays: this.maxReservationDays || null, dailyPrice: this.dailyPrice || null, quantity: this.multiTool ? this.quantity : null, externalUserEmail: this.externalUserEmail || null, externalUserPhoneNumber: this.externalUserPhoneNumber || null, backdatedReservationDate: this.backdatedReservationDate || null });
        this.$toast.success(this.$t('tools.toolLoanedRented'), { timeout: 1500 });
      } catch(e) { console.error(e); this.$toast.danger(this.$t('tools.unableToLoanRent'), { timeout: 0 }); } // eslint-disable-line no-console
      this.$emit('refresh-data'); this.$emit('close');
    },
    isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); },
    checkIfNumber(i) { return !isNaN(i); },
    validateInput() {
      if (this.forceProjectConnectionOnRentals && !this.selectedProject) { this.$toast.danger(this.$t('projects.projectConnectionRequired'), { timeout: 0 }); return false; }
      if (!this.externalUser) { this.$toast.info(this.$t('errors.externalUserEmpty'), { timeout: 2500 }); return false; }
      if (!this.loanOrRent) { this.$toast.info(this.$t('errors.loanRentEmpty'), { timeout: 2500 }); return false; }
      if (this.dailyPrice && !this.checkIfNumber(this.dailyPrice)) { this.$toast.info(this.$t('errors.dailyPriceNotNumber'), { timeout: 2500 }); return false; }
      if (this.maxReservationDays && !this.checkIfNumber(this.maxReservationDays)) { this.$toast.info(this.$t('errors.maxReservationDaysNotNumber'), { timeout: 2500 }); return false; }
      if (this.multiTool && (!this.quantity || !this.checkIfNumber(this.quantity))) { this.$toast.info(this.$t('errors.totalCountEmpty'), { timeout: 2500 }); return false; }
      if (this.multiTool && Number(this.quantity) > this.toolsAvailable) { this.$toast.info(this.$t('errors.quantityNotAvailable'), { timeout: 2500 }); return false; }
      if (this.externalUserEmail && !this.isValidEmail(this.externalUserEmail)) { this.$toast.info(this.$t('errors.invalidEmail'), { timeout: 2500 }); return false; }
      if (this.backdatedReservationDate && new Date(this.backdatedReservationDate) > new Date(this.todayDate)) { this.$toast.info(this.$t('errors.backdatedReservationDateInFuture'), { timeout: 2500 }); return false; }
      return true;
    }
  },
};
</script>
<style>
.el-radio__label { display: none !important; }
.clickable-rows .el-table__row { cursor: pointer; }
.date-clickable { cursor: pointer; }
.rlf-selected-project { font-size: 0.9rem; font-weight: 600; }
</style>
